import { render } from "./BuyInfo.vue?vue&type=template&id=6640d695"
import script from "./BuyInfo.vue?vue&type=script&lang=js"
export * from "./BuyInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__